import { SvgIcon, SvgIconProps } from '@mui/material';

export const MenuSettingsIcon20 = (props?: SvgIconProps): JSX.Element => (
  <SvgIcon
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    sx={{
      width: '20px',
      height: '20px',
    }}
  >
    <g clipPath="url(#clip0_32099_3293)">
      <path
        d="M10.2983 12.584C11.6791 12.584 12.7983 11.4647 12.7983 10.084C12.7983
        8.70327 11.6791 7.58398 10.2983 7.58398C8.91763 7.58398 7.79834 8.70327
        7.79834 10.084C7.79834 11.4647 8.91763 12.584 10.2983 12.584Z"
        color="inherit"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M16.4652 12.5839C16.3542 12.8352 16.3211 13.1141
        16.3702 13.3844C16.4192 13.6547 16.5481 13.9042 16.7402
        14.1006L16.7902 14.1506C16.9451 14.3054 17.0681 14.4892
        17.1519 14.6915C17.2358 14.8938 17.279 15.1107 17.279
        15.3297C17.279 15.5488 17.2358 15.7656 17.1519 15.968C17.0681
        16.1703 16.9451 16.3541 16.7902 16.5089C16.6354 16.6639 16.4516
        16.7868 16.2492 16.8707C16.0469 16.9545 15.83 16.9977 15.611
        16.9977C15.392 16.9977 15.1751 16.9545 14.9728 16.8707C14.7704
        16.7868 14.5866 16.6639 14.4318 16.5089L14.3818 16.4589C14.1854
        16.2668 13.936 16.1379 13.6657 16.0889C13.3953 16.0399 13.1165
        16.073 12.8652 16.1839C12.6187 16.2895 12.4085 16.4649 12.2604
        16.6885C12.1124 16.9121 12.0329 17.1741 12.0318 17.4422V17.5839C12.0318
        18.0259 11.8562 18.4499 11.5437 18.7624C11.2311 19.075 10.8072 19.2506
        10.3652 19.2506C9.92314 19.2506 9.49922 19.075 9.18666 18.7624C8.8741
        18.4499 8.6985 18.0259 8.6985 17.5839V17.5089C8.69205 17.2331 8.60277
        16.9656 8.44226 16.7412C8.28175 16.5167 8.05745 16.3458 7.7985
        16.2506C7.54716 16.1396 7.26834 16.1065 6.99801 16.1556C6.72768
        16.2046 6.47823 16.3335 6.28184 16.5256L6.23184 16.5756C6.07705
        16.7305 5.89323 16.8535 5.6909 16.9373C5.48857 17.0212 5.27169
        17.0644 5.05267 17.0644C4.83364 17.0644 4.61677 17.0212 4.41444
        16.9373C4.2121 16.8535 4.02829 16.7305 3.8735 16.5756C3.71854
        16.4208 3.59561 16.237 3.51174 16.0346C3.42786 15.8323 3.38469
        15.6154 3.38469 15.3964C3.38469 15.1774 3.42786 14.9605 3.51174
        14.7582C3.59561 14.5558 3.71854 14.372 3.8735 14.2172L3.9235
        14.1672C4.11562 13.9708 4.24449 13.7214 4.29351 13.4511C4.34252
        13.1807 4.30943 12.9019 4.1985 12.6506C4.09287 12.4041 3.91747
        12.1939 3.69389 12.0458C3.47031 11.8978 3.20832 11.8183 2.94017
        11.8172H2.7985C2.35647 11.8172 1.93255 11.6416 1.61999
        11.3291C1.30743 11.0165 1.13184 10.5926 1.13184 10.1506C1.13184
        9.70854 1.30743 9.28462 1.61999 8.97206C1.93255 8.6595 2.35647
        8.4839 2.7985 8.4839H2.8735C3.14933 8.47745 3.41684 8.38817
        3.64125 8.22766C3.86566 8.06715 4.0366 7.84285 4.13184
        7.5839C4.24276 7.33256 4.27586 7.05374 4.22684 6.78341C4.17782
        6.51308 4.04895 6.26363 3.85684 6.06724L3.80684 6.01724C3.65187
        5.86245 3.52894 5.67863 3.44507 5.4763C3.3612 5.27397 3.31802
        5.0571 3.31802 4.83807C3.31802 4.61904 3.3612 4.40217 3.44507
        4.19984C3.52894 3.99751 3.65187 3.81369 3.80684 3.6589C3.96162
        3.50394 4.14544 3.38101 4.34777 3.29714C4.5501 3.21326 4.76698
        3.17009 4.986 3.17009C5.20503 3.17009 5.42191 3.21326 5.62424
        3.29714C5.82657 3.38101 6.01038 3.50394 6.16517 3.6589L6.21517
        3.7089C6.41157 3.90102 6.66102 4.02989 6.93134 4.07891C7.20167
        4.12792 7.48049 4.09483 7.73184 3.9839H7.7985C8.04498 3.87827
        8.25518 3.70287 8.40325 3.47929C8.55131 3.25572 8.63077
        2.99372 8.63184 2.72557V2.5839C8.63184 2.14188 8.80743
        1.71795 9.11999 1.40539C9.43255 1.09283 9.85647 0.917236
        10.2985 0.917236C10.7405 0.917236 11.1645 1.09283 11.477
        1.40539C11.7896 1.71795 11.9652 2.14188 11.9652 2.5839V2.6589C11.9662
        2.92706 12.0457 3.18905 12.1938 3.41262C12.3418 3.6362 12.552 3.8116
        12.7985 3.91724C13.0498 4.02817 13.3287 4.06126 13.599
        4.01224C13.8693 3.96322 14.1188 3.83435 14.3152 3.64224L14.3652
        3.59224C14.52 3.43728 14.7038 3.31434 14.9061 3.23047C15.1084
        3.1466 15.3253 3.10343 15.5443 3.10343C15.7634 3.10343 15.9802
        3.1466 16.1826 3.23047C16.3849 3.31434 16.5687 3.43728 16.7235
        3.59224C16.8785 3.74702 17.0014 3.93084 17.0853 4.13317C17.1691
        4.3355 17.2123 4.55238 17.2123 4.7714C17.2123 4.99043 17.1691
        5.20731 17.0853 5.40964C17.0014 5.61197 16.8785 5.79578 16.7235
        5.95057L16.6735 6.00057C16.4814 6.19697 16.3525 6.44642 16.3035
        6.71675C16.2545 6.98707 16.2876 7.26589 16.3985 7.51724V7.5839C16.5041
        7.83038 16.6795 8.04058 16.9031 8.18865C17.1267 8.33671 17.3887 8.41617
        17.6568 8.41724H17.7985C18.2405 8.41724 18.6645 8.59283 18.977
        8.90539C19.2896 9.21795 19.4652 9.64187 19.4652 10.0839C19.4652
        10.5259 19.2896 10.9499 18.977 11.2624C18.6645 11.575 18.2405
        11.7506 17.7985 11.7506H17.7235C17.4553 11.7516 17.1934 11.8311
        16.9698 11.9792C16.7462 12.1272 16.5708 12.3374 16.4652 12.5839V12.5839Z"
        color="inherit"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </g>
    <defs>
      <clipPath id="clip0_32094_3293">
        <rect
          width="20"
          height="20"
          fill="none"
          transform="translate(0.29834 0.0839844)"
        />
      </clipPath>
    </defs>
  </SvgIcon>
);

// <svg
//   width="21"
//   height="21"
//   viewBox="0 0 21 21"
//   fill="none"
//   xmlns="http://www.w3.org/2000/svg"
// >
//   <g
//     clipPath="url(#clip0_32099_3293)"
//   >
//     <path d="M10.2983 12.584C11.6791 12.584 12.7983 11.4647 12.7983 10.084C12.7983 8.70327 11.6791 7.58398 10.2983 7.58398C8.91763 7.58398 7.79834 8.70327 7.79834 10.084C7.79834 11.4647 8.91763 12.584 10.2983 12.584Z" stroke="#1E293B" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
//     <path d="M16.4652 12.5839C16.3542 12.8352 16.3211 13.1141 16.3702 13.3844C16.4192 13.6547 16.5481 13.9042 16.7402 14.1006L16.7902 14.1506C16.9451 14.3054 17.0681 14.4892 17.1519 14.6915C17.2358 14.8938 17.279 15.1107 17.279 15.3297C17.279 15.5488 17.2358 15.7656 17.1519 15.968C17.0681 16.1703 16.9451 16.3541 16.7902 16.5089C16.6354 16.6639 16.4516 16.7868 16.2492 16.8707C16.0469 16.9545 15.83 16.9977 15.611 16.9977C15.392 16.9977 15.1751 16.9545 14.9728 16.8707C14.7704 16.7868 14.5866 16.6639 14.4318 16.5089L14.3818 16.4589C14.1854 16.2668 13.936 16.1379 13.6657 16.0889C13.3953 16.0399 13.1165 16.073 12.8652 16.1839C12.6187 16.2895 12.4085 16.4649 12.2604 16.6885C12.1124 16.9121 12.0329 17.1741 12.0318 17.4422V17.5839C12.0318 18.0259 11.8562 18.4499 11.5437 18.7624C11.2311 19.075 10.8072 19.2506 10.3652 19.2506C9.92314 19.2506 9.49922 19.075 9.18666 18.7624C8.8741 18.4499 8.6985 18.0259 8.6985 17.5839V17.5089C8.69205 17.2331 8.60277 16.9656 8.44226 16.7412C8.28175 16.5167 8.05745 16.3458 7.7985 16.2506C7.54716 16.1396 7.26834 16.1065 6.99801 16.1556C6.72768 16.2046 6.47823 16.3335 6.28184 16.5256L6.23184 16.5756C6.07705 16.7305 5.89323 16.8535 5.6909 16.9373C5.48857 17.0212 5.27169 17.0644 5.05267 17.0644C4.83364 17.0644 4.61677 17.0212 4.41444 16.9373C4.2121 16.8535 4.02829 16.7305 3.8735 16.5756C3.71854 16.4208 3.59561 16.237 3.51174 16.0346C3.42786 15.8323 3.38469 15.6154 3.38469 15.3964C3.38469 15.1774 3.42786 14.9605 3.51174 14.7582C3.59561 14.5558 3.71854 14.372 3.8735 14.2172L3.9235 14.1672C4.11562 13.9708 4.24449 13.7214 4.29351 13.4511C4.34252 13.1807 4.30943 12.9019 4.1985 12.6506C4.09287 12.4041 3.91747 12.1939 3.69389 12.0458C3.47031 11.8978 3.20832 11.8183 2.94017 11.8172H2.7985C2.35647 11.8172 1.93255 11.6416 1.61999 11.3291C1.30743 11.0165 1.13184 10.5926 1.13184 10.1506C1.13184 9.70854 1.30743 9.28462 1.61999 8.97206C1.93255 8.6595 2.35647 8.4839 2.7985 8.4839H2.8735C3.14933 8.47745 3.41684 8.38817 3.64125 8.22766C3.86566 8.06715 4.0366 7.84285 4.13184 7.5839C4.24276 7.33256 4.27586 7.05374 4.22684 6.78341C4.17782 6.51308 4.04895 6.26363 3.85684 6.06724L3.80684 6.01724C3.65187 5.86245 3.52894 5.67863 3.44507 5.4763C3.3612 5.27397 3.31802 5.0571 3.31802 4.83807C3.31802 4.61904 3.3612 4.40217 3.44507 4.19984C3.52894 3.99751 3.65187 3.81369 3.80684 3.6589C3.96162 3.50394 4.14544 3.38101 4.34777 3.29714C4.5501 3.21326 4.76698 3.17009 4.986 3.17009C5.20503 3.17009 5.42191 3.21326 5.62424 3.29714C5.82657 3.38101 6.01038 3.50394 6.16517 3.6589L6.21517 3.7089C6.41157 3.90102 6.66102 4.02989 6.93134 4.07891C7.20167 4.12792 7.48049 4.09483 7.73184 3.9839H7.7985C8.04498 3.87827 8.25518 3.70287 8.40325 3.47929C8.55131 3.25572 8.63077 2.99372 8.63184 2.72557V2.5839C8.63184 2.14188 8.80743 1.71795 9.11999 1.40539C9.43255 1.09283 9.85647 0.917236 10.2985 0.917236C10.7405 0.917236 11.1645 1.09283 11.477 1.40539C11.7896 1.71795 11.9652 2.14188 11.9652 2.5839V2.6589C11.9662 2.92706 12.0457 3.18905 12.1938 3.41262C12.3418 3.6362 12.552 3.8116 12.7985 3.91724C13.0498 4.02817 13.3287 4.06126 13.599 4.01224C13.8693 3.96322 14.1188 3.83435 14.3152 3.64224L14.3652 3.59224C14.52 3.43728 14.7038 3.31434 14.9061 3.23047C15.1084 3.1466 15.3253 3.10343 15.5443 3.10343C15.7634 3.10343 15.9802 3.1466 16.1826 3.23047C16.3849 3.31434 16.5687 3.43728 16.7235 3.59224C16.8785 3.74702 17.0014 3.93084 17.0853 4.13317C17.1691 4.3355 17.2123 4.55238 17.2123 4.7714C17.2123 4.99043 17.1691 5.20731 17.0853 5.40964C17.0014 5.61197 16.8785 5.79578 16.7235 5.95057L16.6735 6.00057C16.4814 6.19697 16.3525 6.44642 16.3035 6.71675C16.2545 6.98707 16.2876 7.26589 16.3985 7.51724V7.5839C16.5041 7.83038 16.6795 8.04058 16.9031 8.18865C17.1267 8.33671 17.3887 8.41617 17.6568 8.41724H17.7985C18.2405 8.41724 18.6645 8.59283 18.977 8.90539C19.2896 9.21795 19.4652 9.64187 19.4652 10.0839C19.4652 10.5259 19.2896 10.9499 18.977 11.2624C18.6645 11.575 18.2405 11.7506 17.7985 11.7506H17.7235C17.4553 11.7516 17.1934 11.8311 16.9698 11.9792C16.7462 12.1272 16.5708 12.3374 16.4652 12.5839V12.5839Z" stroke="#1E293B" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
//   </g>
//   <defs>
//     <clipPath id="clip0_32099_3293">
//       <rect width="20" height="20" fill="white" transform="translate(0.29834 0.0839844)" />
//     </clipPath>
//   </defs>
// </svg>;
